<template>
  <div class="open-ai-tab-content">
    <div class ="data-loading" v-if="this.$store.state.openAi.searchLoading">
    </div>
    <div class ="tab-no-data" v-else-if="(solutions.length + serviceRequests.length) == 0">
			<div class="no-data-text">{{this.$store.state.sysInit.html_const.cons_219_no_data}}</div>
		</div>
    <div v-else class="tab-content-data">
      <!-- <div class="op-content">
        <img
          class="img_operator"
          :src="this.$store.state.sysInit.operator_logo"
          alt=""
        />
        <div class="op-input">{{ userQuery }}</div>
      </div> -->
      <div class="open-ai-content">
        <!-- <img class="icon_openai" src="../assets/img/footer_btn2.png" alt="" /> -->
        <div class="open-ai-solutions">
          <!-- <div class="examples-content">
            <div class="solution-content">
              <div class ="content-outline">
                <div class ="content-title">{{this.$store.state.sysInit.html_const.cons_274_generative_ai_text1}}</div>
                <div v-for="oneExample in solutions" :key="oneExample.id">
                    <a class="solution-link" @click="linkClick(oneExample)"># {{ oneExample.contentId + ': ' + oneExample.title }}</a>
                </div>
              </div>  
            </div>
            <div class="service-request-content">
               <div class ="content-outline">
                  <div class ="content-title" >{{this.$store.state.sysInit.html_const.cons_275_generative_ai_text2}}</div>
                  <div v-for="oneExample in  serviceRequests" :key="oneExample.id">
                    <a class="solution-link" @click="linkClick(oneExample)"># {{ oneExample.contentId + ': ' + oneExample.title }}</a>
                  </div>
               </div> 
            </div>
          </div> -->
          <div  v-if = "showEstimateQuestion"  class ="open-ai-estimation">
            <div class ="_content-title" v-html="this.$store.state.sysInit.html_const.cons_278_generative_ai_text5"></div>
            <div class="content-comment" v-html="this.$store.state.sysInit.html_const.cons_279_generative_ai_text6"></div>
            <div class = ""> {{ estimateQuestion }}</div>
          </div>
          <div :class =" showEstimateQuestion ?'ai-scripts-content' : 'ai-scripts-content-max'">
            <div class ="solution-script">
              <div class ="content-outline script-content">
                <div class ="content-title" v-html="this.$store.state.sysInit.html_const.cons_276_generative_ai_text3">
                </div>
                <div>
                  <p v-html="finalSolution"></p>
                </div>
              </div>
            </div>
            <!-- <div class="content-margin-top">お待たせいたしました。</div> -->
            <div class ="question-script">
              <div class ="content-outline script-content">
                <div class ="content-title" v-html="this.$store.state.sysInit.html_const.cons_277_generative_ai_text4">
                </div>
                  <!-- <div class="content-margin-top">お待たせいたしました。</div> -->
                <div>
                  <p v-html="questions"></p>
                </div>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'openAiTab',
  computed: {
    showEstimateQuestion(){
      return this.$store.state.openAi.type == "dialogue"
    },
    estimateQuestion(){
      return this.$store.state.openAi.estimateQuestion
    },
    solutions () {
      return this.$store.state.openAi.solutions
    },
    serviceRequests (){
      return this.$store.state.openAi.serviceRequests
    },
    finalSolution () {
      return this.$store.state.openAi.openAiSolution.replace(/\n/g, '<br>')
    },
    questions(){
      return this.$store.state.openAi.openAiQuestions.replace(/\n/g, '<br>')
    },
    userQuery () {
      return this.$store.state.openAi.userQuery
    }
  },
	methods:{
		linkClick(item){
      let _type = item.type.toLowerCase();
      _type = _type == 'solution' ? _type : 'plusgsr';
      window.open('https://sno1.manage.inst1.apps.mas.sswjp.net/maximo/oslc/graphite/manage-shell/index.html?event=loadapp&value=' + 
      _type + "&uniqueid=" + item.uid);
    },
	}
}
</script>

<style lang="scss" scoped>
.data-loading{
  background: url("../assets/img/moppy.gif") center center/32px no-repeat;
  height: 100%;
  width: 100%;
  top: 0px;
}
.tab-content-data{
  height: 100%;
}
.open-ai-estimation {
  padding: 8px;
  border-radius: 8px;
  border: solid 1px #d6d7d9;
  height: 110px;
  overflow-y: auto;

}
.content-title {
  font-size: 14px;
  // color: #039be5;
  font-weight: bold;
  text-align: center;
  margin-bottom:8px;
  margin-top:4px;

}
.content-outline {
  // border: solid 2px #8cc5ff;
  height: 100%;
  padding: 8px;
  border-radius: 8px;
  // box-shadow: 0 2px 4px rgb(30 29 29 / 12%), 0 0 6px rgb(8 8 8 / 4%);
  // background: #f3f1f199;
  border: solid 1px #d6d7d9; //#DCDFE6 #c0c4cc
  // background: #f3f1f199;
  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.examples-content {
  display: flex;
  min-height: 120px;
  .solution-content {
    width: 50%;
    padding-right: 8px;
    min-width: 50%;
  }
  .service-request-content{
    padding-left: 8px;
    width: 50%;
  }
}
.ai-scripts-content-max {
  display: flex;
  height: calc(100% - 0px);

}
.ai-scripts-content {
  display: flex;
  margin-top:16px;
  height: calc(100% - 134px);
}
.solution-script{
  width: 50%;
  padding-right: 8px;
  min-width: 50%;
  // max-height: 100%;
  // overflow-y: auto;
}
.script-content{
  max-height: 100%;
  overflow-y: auto;
}
.question-script{
    padding-left: 8px;
    width: 50%;
  }
.open-ai-tab-content {
  padding: 16px;
  height: 100%;
  overflow-y: auto;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
}
.op-input {
  font-size: 14px;
  color: #039be5;
  font-weight: bold;
  margin-left: 8px;
}
.op-content {
  display: flex;
  line-height: 32px;
}
.img_operator {
  border-radius: 50%;
  width: 32px;
  height: 32px;
}
.icon_openai {
  width: 32px;
  height: 32px;
}
.open-ai-content {
  display: flex;
  padding-top: 8px;
  height: 100%;
}
.open-ai-solutions {
  // margin-left: 8px;
  height: 100%;
  overflow-wrap: break-word;
}
.content-margin-top {
  margin-top: 8px;
}
.tab-no-data {
	display: flex;
  height: 100%
}
.no-data-text {
	margin:auto;
	color: #909399
}
.solution-link {
  cursor: pointer;
	text-decoration: underline;
  // color: #606266;
  // font-weight: 500;
}
// a:hover{ /* color: #0279b3; */
//   color:#0279b3
// }
  ._content-title {
    font-size: 14px;
    // color: #039be5;
    font-weight: bold;
    text-align: center;
    margin-top:4px;
  }
  .content-comment{
    text-align: center;
    margin-bottom: 15px;
    font-size: 12px;
    color: #2F8D02;
  }

</style>
